const gsv = window.LOCAL_CONFIG.UC_GSV
const bs_gsv = window.LOCAL_CONFIG.BS_GSV
const file_gsv = window.LOCAL_CONFIG.FILE_GSV
/**
 * 保存用户信息
 * @returns {*}
 */
export function saveUserInfo (option) {
  return window.fetch.post(gsv + '/ws/user/save_user_info', option)
}

/**
 * 保存用户信息
 * @returns {*}
 */
export function saveOperatorInfo (option) {
  return window.fetch.post(gsv + '/ws/user/save_operator_info', option)
}

/**
 * 查询品种树
 * @returns {*}
 */
export function queryVarietyTreeJson (option) {
  return window.fetch.post(bs_gsv + '/ext/variety/get_variety_tree_ext', option)
}

/**
 * 查询市场列表
*/
export function getMarketList (option) {
  return window.fetch.post(bs_gsv + '/ext/market/get_market_info_list_ext', option)
}
/**
 * 快捷注册
*/
export function quickReg (option) {
  return window.fetch.post(gsv + '/ws/user/quick_reg', option)
}
/**
 * 根据用户获取业务资格信息
 * {已申请业务资格 待审核业务资格 可申请业务资格}
 */
export function getUserTypeByUser (option) {
  return window.fetch.post(gsv + '/ws/user/get_user_type_by_user', option)
}
/**
 * 获取业务资格补充信息
 */
export function getUserTypeExtAttr (option) {
  return window.fetch.post(gsv + '/ws/user/get_usertype_extattr', option)
}
/**
 * 提交业务资格申请
 */
export function saveUserTypeDetail (option) {
  return window.fetch.post(gsv + '/ws/user/save_user_type_detail', option)
}
/**
 * 密码重置
 * @param {*} option
 */
export function resetPwd (option) {
  return window.fetch.post(gsv + '/ws/user/edit_pwd', option)
}
/**
 获取数据字典信息
 */
export function getDicts (option) {
  return window.fetch.post(bs_gsv + '/ext/datadict/get_basic_data_dict_list_ext', option)
}
/**
 修改用户状态
 */
export function changeStatus (option) {
  return window.fetch.post(gsv + '/ws/user/change_user_status', option)
}

/**
 用户强制下线
 */
export function userOffLine (option) {
  return fetch.post(gsv + '/ws/user/off_line', option)
}
/**
 获取文件base64
 */
export function getFile64 (option) {
  return window.fetch.post(file_gsv + '/clound/file/get_img_data', option)
}
/**
 查询经纪商
 */
export function getParentAgentUser (option) {
  return window.fetch.post(gsv + '/ws/user/get_agent', option)
}

/**
 查询分中心
 */
export function getPrivilegeGroup (option) {
  return window.fetch.post(gsv + '/ws/user/privilege_group', option)
}